import React, { useRef } from 'react';
import Box from '@material-ui/core/Box';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Fade, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ReactHtmlParser from 'react-html-parser';
import IconButton from '@material-ui/core/IconButton';
import stripHtmlTags from '../../../../../../helpers/stripHtmlTags';

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    minWidth: 650,
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& .se-video-container > figure': {
      paddingBottom: '0 !important'
    }
  }
}));

const ContextHelp = ({ content, children, alignment, leftMargin, topMargin, ...props }) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const anchorRef = useRef();

  const identifyPosition = () => {
    if (anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      let parent = anchorRef.current;
      while (parent && parent.id !== 'main-rxform') {
        parent = parent.parentElement;
      }

      const parentRect = parent?.getBoundingClientRect() || { left: 0 };
      const relativeLeft = rect.left - parentRect.left;
      const parentWidth = parent?.clientWidth || 0;
      if (relativeLeft > parentWidth * 0.75) {
        return 'top-end';
      }
      if (relativeLeft < parentWidth * 0.25) {
        return 'top-start';
      }
      return 'top';
    }
  };

  if (!content || (content.length < 12 && !stripHtmlTags(content))) {
    return children;
  }

  const handleOpen = e => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  const useModal = content?.includes('se-video-container');
  const htmlContent = ReactHtmlParser(content);
  return (
    <>
      <Box display="flex" alignItems={alignment} {...props}>
        {children}
        {!useModal && (
          <>
            <div style={{ display: 'flex', marginLeft: leftMargin, marginTop: topMargin }}>
              <InfoOutlinedIcon
                color="primary"
                ref={anchorRef}
                onMouseOver={() => setOpen(true)}
                onMouseOut={() => setOpen(false)}
              />
            </div>
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              placement={open ? identifyPosition() : 'top'}
              style={{ zIndex: 10000 }}
              transition
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Paper elevation={3} style={{ maxWidth: 900, minWidth: 300, padding: 16 }}>
                    {htmlContent}
                  </Paper>
                </Fade>
              )}
            </Popper>
          </>
        )}
        {useModal && (
          <>
            <div style={{ marginLeft: leftMargin, marginTop: topMargin }}>
              <IconButton style={{ padding: 0 }} onClick={handleOpen}>
                <InfoOutlinedIcon color="primary" />
              </IconButton>
            </div>
            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              <Paper className={classes.paper} elevation={2}>
                {htmlContent}
              </Paper>
            </Modal>
          </>
        )}
      </Box>
    </>
  );
};

ContextHelp.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node.isRequired,
  alignment: PropTypes.string,
  leftMargin: PropTypes.number,
  topMargin: PropTypes.number
};

ContextHelp.defaultProps = {
  content: null,
  alignment: 'center',
  leftMargin: 0,
  topMargin: 0
};

export default ContextHelp;
